/* eslint-disable no-underscore-dangle */
import { chromeYellow } from '@cogneed/react-utils';
import { alpha } from '@mui/material';

import type {
  LexicalNode,
  NodeKey,
  SerializedTextNode,
  Spread,
} from 'lexical';

import { $applyNodeReplacement, TextNode } from 'lexical';

export const SEARCH_CONTEXT_TYPE = 'search-context';
export const contextColor = alpha(chromeYellow[300], 0.7);
export const contextStyle = `background-color: ${contextColor}`;

function styleMatch(nodeStyle: string) {
  const start = nodeStyle === '' ? '' : `${nodeStyle};`;
  return `${start}${contextStyle}`;
}

export type SerializedSearchContextNode = Spread<
  {
    className: string;
  },
  SerializedTextNode
>;

export class SearchContextNode extends TextNode {
  __className: string;

  static getType(): string {
    return SEARCH_CONTEXT_TYPE;
  }

  static clone(node: SearchContextNode): SearchContextNode {
    return new SearchContextNode(node.__className, node.__text, node.__key);
  }

  constructor(className: string, text: string, key?: NodeKey) {
    super(text, key);
    this.__className = className;
  }

  static importJSON(serializedNode: SerializedSearchContextNode): SearchContextNode {
    const node = $createSearchContextNode(
      serializedNode.className,
      serializedNode.text,
    );
    node.setFormat(serializedNode.format);
    node.setDetail(serializedNode.detail);
    node.setMode(serializedNode.mode);
    node.setStyle(styleMatch(serializedNode.style));
    return node;
  }

  exportJSON(): SerializedSearchContextNode {
    return {
      ...super.exportJSON(),
      className: this.getClassName(),
      type: SEARCH_CONTEXT_TYPE,
    };
  }

  getClassName(): string {
    const self = this.getLatest();
    return self.__className;
  }
}

export function $isSearchContextNode(
  node: LexicalNode | null | undefined,
): node is SearchContextNode {
  return node instanceof SearchContextNode;
}

export function $createSearchContextNode(
  className: string,
  emojiText: string,
): SearchContextNode {
  const node = new SearchContextNode(className, emojiText).setMode('token');
  return $applyNodeReplacement(node);
}
